import { Typography } from '@/components';

export function MyOffersHeader() {
  return (
    <div>
      <Typography as="h1" size="heading-2" weight="semibold" className="mb-2">
        Buyer Dashboard
      </Typography>
    </div>
  );
}
